function generateImageUrls(prefix: string, count: number): string[] {
  const urls = [];
  for (let i = 1; i <= count; i++) {
    urls.push(`assets/img/rooms/${prefix}_${i}.jpg`);
  }
  return urls;
}

export const environment = {
  production: true,
  url: '',
  api_url: 'https://hotelgdansk-booking.virtualreception.pl/api/',
  hotel_name: 'Hotel Gdańsk',
  html_title: '',
  privacy_policy: '',
  hotel_rules: '',
  mainTitle: "",
  hotel_url: 'https://www.hotelgdansk.com.pl',
  instagram_url: '',
  facebook_url: '',
  linkedin_url: '',
  asorts: true,
  isBreakfastRequired: false,
  isBreakfastDefaultSelected: false,
  breakfastCheckbox: true,
  localizationSelect: false,
  rabatInput: true,
  isApart: false,
  minimalStayDays: 1,
  localChargeOptionActive: false,
  voucherOptionActive: true,
  offersOptionActive: false,
  breakfastOptionActive: false,
  parkingOptionActive: false,
  localCharge: false,
  paymentImagePath: 'assets/img/background.jpg',
  isLanguageChange: false,
  gtm: false,
  gtmtag: '',
  hiddenIcons: false,
  favicon_url: '',
  layoutSettings: {
    footer: {
      addressLine1: 'Hotel Gdańsk',
      addressLine2: 'ul. Szafarnia 9, 80-755 Gdańsk',
    },
  },
  messageForNoRooms: 'Brak pokoi w wybranym terminie',
  roomTypeToImagesMap: {},
  roomDetails: true,
  rooms: [{
      type: "Superior z balkonem",
      roomNumbers: [11, 15, 23, 26, 36, 45],
      mainDescription: {
        view: "jezioro",
        bed: "łóżko małżeńskie z możliwością rozłączenia na dwa pojedyncze",
        extraBed: "rozkładany fotel",
        airConditioning: "indywidualnie sterowana",
        bathroom: "łazienka z prysznicem",
        towels: true,
        fridge: true,
        size: 21,
        maxGuests: 3,
        elevator: true,
      },
      icons: {
        "features": {
          "balcony": "balcony",
        },
        "roomType": "hotel",
        "view": "visibility",
        "bed": "king_bed",
        "airConditioning": "ac_unit",
        "bathroom": "shower",
        "towels": "dry_cleaning",
        "fridge": "kitchen",
        "size": "square_foot",
        "maxGuests": "groups"
      },
      detailedEquipment: [
        "łóżko małżeńskie z możliwością rozłączenia na dwa pojedyncze",
        "rozkładany fotel",
        "TV",
        "internet",
        "toaletka z lustrem",
        "lodówka",
        "klimatyzacja indywidualnie sterowana",
        "suszarka do włosów",
        "zestaw herbata / kawa",
        "ręczniki",
        "kosmetyki",
        "łazienka z prysznicem"
      ],
      description: "Spędź wyjątkowy czas w pokoju typu Superior z zapierającym dech w piesi widokiem na jezioro. Przestrzeń jest jasna i funkcjonalna, a dzięki białym oraz błękitnym elementom wystroju wnętrza poczujesz się w strefie komfortu i wypoczynku. Pokój zawiera elegancką łazienkę z prysznicem zaopatrzoną w kosmetyki, ręczniki oraz suszarkę do włosów. Do czasu zakończenia remontu restauracji oferujemy gościom śniadania a'la carte w restauracji oddalonej o 40 metrów od Naszego hotelu. W ofercie za dodatkową opłatą posiadamy również łóżeczka turystyczne dla Naszych najmłodszych gości oraz wyrażamy zgodę na pobyt Waszego pupila zgodnie z regulaminem."
    },
    {
      type: "Apartament z tarasem",
      roomNumbers: [21],
      mainDescription: {
        features: ["salon z aneksem kuchennym", "taras"],
        bed: "sypialnia z łóżkiem małżeńskim",
        extraBed: "rozkładana kanapa",
        airConditioning: "indywidualnie sterowana",
        bathroom: "łazienka z prysznicem",
        towels: true,
        fridge: true,
        size: 32,
        maxGuests: 4,
        elevator: true,
      },
      icons: {
        "roomType": "meeting_room",
        "view": "landscape",
        "bed": "bed",
        "airConditioning": "air",
        "bathroom": "bathroom",
        "towels": "dry_cleaning",
        "fridge": "kitchen",
        "size": "straighten",
        "maxGuests": "people_alt",
      },
      detailedEquipment: [
        "salon z aneksem kuchennym (lodówka, płyta indukcyjna, piekarnik)",
        "taras",
        "rozkładana kanapa",
        "sypialnia z łóżkiem małżeńskim",
        "TV w salonie oraz sypialni",
        "internet",
        "klimatyzacja indywidualnie sterowana",
        "suszarka do włosów",
        "zestaw kawa / herbata",
        "ręczniki",
        "kosmetyki",
        "łazienka z prysznicem"
      ],
      description: "Spędź wyjątkowy czas w Apartamencie który zachwyca przytulną atmosferą oraz detalami, dzięki którym poczujecie się jak w domu. Przestrzeń jest jasna i funkcjonalna, a dzięki białym oraz błękitnym elementom wystroju wnętrza poczujesz się w strefie komfortu i wypoczynku. Pokój zawiera elegancką łazienkę z prysznicem zaopatrzoną w kosmetyki, ręczniki oraz suszarkę do włosów. Do czasu zakończenia remontu restauracji oferujemy gościom śniadania a'la carte w restauracji oddalonej o 40 metrów od Naszego hotelu. W ofercie za dodatkową opłatą posiadamy również łóżeczka turystyczne dla Naszych najmłodszych gości oraz wyrażamy zgodę na pobyt Waszego pupila zgodnie z regulaminem."
    },
    {
      type: "Pokój Basic",
      roomNumbers: [32, 42],
      mainDescription: {
        features: [],
        bed: "łóżko pojedyncze",
        extraBed: "rozkładana kanapa",
        airConditioning: "indywidualnie sterowana",
        bathroom: "łazienka z prysznicem",
        towels: true,
        fridge: true,
        size: 15,
        maxGuests: 1,
        elevator: true,
      },
      icons: {
        "roomType": "meeting_room",
        "view": "landscape",
        "bed": "bed",
        "airConditioning": "air",
        "bathroom": "bathroom",
        "towels": "dry_cleaning",
        "fridge": "kitchen",
        "size": "straighten",
        "maxGuests": "people_alt",
      },
      detailedEquipment: [
        "łóżko pojedyncze",
        "TV",
        "internet",
        "toaletka z lsustrem",
        "lodówka",
        "klimatyzacja indywidualnie sterowana",
        "zestaw kawa / herbata",
        "ręczniki",
        "kosmetyki",
        "łazienka z prysznicem",
        "suszarka do włosów"
      ],
      description: "Spędź wyjątkowy czas w pokoju typu Basic który zachwyca przytulną atmosferą oraz detalami, dzięki którym poczujecie się jak w domu. Przestrzeń jest jasna i funkcjonalna, a dzięki białym oraz błękitnym elementom wystroju wnętrza poczujesz się w strefie komfortu i wypoczynku. Pokój zawiera elegancką łazienkę z prysznicem zaopatrzoną w kosmetyki, ręczniki oraz suszarkę do włosów. Do czasu zakończenia remontu restauracji oferujemy gościom śniadania a'la carte w restauracji oddalonej o 40 metrów od Naszego hotelu. W ofercie za dodatkową opłatą posiadamy również łóżeczka turystyczne dla Naszych najmłodszych gości oraz wyrażamy zgodę na pobyt Waszego pupila zgodnie z regulaminem."
    },
    {
      type: "Pokój Classic",
      roomNumbers: [22, 33, 43],
      mainDescription: {
        view: "taras/balkon/okna dachowe",
        bed: "łóżko małżeńskie z możliwością rozłączenia na dwa pojedyncze",
        airConditioning: "indywidualnie sterowana",
        bathroom: "łazienka z prysznicem",
        towels: true,
        fridge: true,
        size: 20,
        maxGuests: 2,
        elevator: true,
      },
      icons: {
        "features": {
          "balcony": "balcony",
          "kitchen": "kitchen",
        },
        "view": "visibility",
        "bed": "bed",
        "extraBed": "weekend",
        "airConditioning": "air",
        "bathroom": "shower",
        "towels": "dry_cleaning",
        "fridge": "kitchen",
        "size": "straighten",
        "maxGuests": "people_alt"
      },
      detailedEquipment: [
        "TV",
        "internet",
        "toaletka z lustrem",
        "lodówka",
        "klimatyzacja indywidualnie sterowana",
        "zestaw kawa / herbata",
        "ręczniki",
        "kosmetyki",
        "łazienka z prysznicem",
        "suszarka do włosów"
      ],
      description: "Spędź wyjątkowy czas w pokoju typu Classic który zachwyca przytulną atmosferą oraz detalami, dzięki którym poczujecie się jak w domu. Przestrzeń jest jasna i funkcjonalna, a dzięki białym oraz błękitnym elementom wystroju wnętrza poczujesz się w strefie komfortu i wypoczynku.Pokój zawiera elegancką łazienkę z prysznicem zaopatrzoną w kosmetyki, ręczniki oraz suszarkę do włosów. Do czasu zakończenia remontu restauracji oferujemy gościom śniadania a'la carte w restauracji oddalonej o 40 metrów od Naszego hotelu. W ofercie za dodatkową opłatą posiadamy również łóżeczka turystyczne dla Naszych najmłodszych gości oraz wyrażamy zgodę na pobyt Waszego pupila zgodnie z regulaminem."
    },
    {
      type: "De Lux",
      roomNumbers: [34],
      mainDescription: {
        features: ["balkon z widokiem na jezioro", "salon z aneksem kuchennym"],
        bed: "sypialnia z łóżkiem małżeńskim",
        extraBed: "rozkładana kanapa",
        airConditioning: "indywidualnie sterowana",
        bathroom: "łazienka z wanną",
        towels: true,
        fridge: true,
        size: 45,
        maxGuests: 4,
        elevator: true,
      },
      icons: {
        "features": {
          "balcony": "balcony",
          "kitchen": "kitchen",
        },
        "bed": "bed",
        "extraBed": "weekend",
        "airConditioning": "air",
        "bathroom": "bathtub",
        "towels": "bath_towel",
        "fridge": "kitchen",
        "size": "straighten",
        "maxGuests": "people_alt"
      },
      detailedEquipment: [
        "salon z aneksem kuchennym (lodówka, płyta indukcyjna, piekarnik, zmywarka)",
        "rozkładana kanapa",
        "sypialnia z łóżkiem małżeńskim",
        "TV w salonie oraz sypialni",
        "internet",
        "toaletka z lustrem",
        "klimatyzacja indywidualnie sterowana",
        "suszarka do włosów",
        "ręczniki",
        "kosmetyki",
        "łazienka z wanną",
      ],
      description: "Spędź wyjątkowy czas w pokoju typu De Lux z zapierającym dech w piesi widokiem na jezioro. Przestrzeń jest jasna i funkcjonalna, a dzięki białym oraz błękitnym elementom wystroju wnętrza poczujesz się w strefie komfortu i wypoczynku.Pokój zawiera elegancką łazienkę z wanną zaopatrzoną w kosmetyki, ręczniki oraz suszarkę do włosów. Aneks kuchenny zapewnia wszystkie niezbędne rzeczy do codziennego funkcjonowania.Do czasu zakończenia remontu restauracji oferujemy gościom śniadania a'la carte w restauracji oddalonej o 40 metrów od Naszego hotelu. W ofercie za dodatkową opłatą posiadamy również łóżeczka turystyczne dla Naszych najmłodszych gości oraz wyrażamy zgodę na pobyt Waszego pupila zgodnie z regulaminem."
    },
       {
      type: "Studio",
      roomNumbers: [47],
      mainDescription: {
        features: ["balkon z widokiem na jezioro", "salon z aneksem kuchennym"],
        bed: "sypialnia z łóżkiem małżeńskim",
        extraBed: "rozkładana kanapa",
        airConditioning: "indywidualnie sterowana",
        bathroom: "łazienka z wanną",
        towels: true,
        fridge: true,
        size: 45,
        maxGuests: 4,
        elevator: true,
      },
      icons: {
        "features": {
          "balcony": "balcony",
          "kitchen": "kitchen",
        },
        "bed": "bed",
        "extraBed": "weekend",
        "airConditioning": "air",
        "bathroom": "bathtub",
        "towels": "bath_towel",
        "fridge": "kitchen",
        "size": "straighten",
        "maxGuests": "people_alt"
      },
      detailedEquipment: [
        "salon z aneksem kuchennym (lodówka, płyta indukcyjna, piekarnik, zmywarka)",
        "rozkładana kanapa",
        "sypialnia z łóżkiem małżeńskim",
        "TV w salonie oraz sypialni",
        "internet",
        "toaletka z lustrem",
        "klimatyzacja indywidualnie sterowana",
        "suszarka do włosów",
        "ręczniki",
        "kosmetyki",
        "łazienka z wanną"
      ],
      description: "Spędź wyjątkowy czas w pokoju typu Studio z zapierającym dech w piesi widokiem na jezioro. Przestrzeń jest jasna i funkcjonalna, a dzięki białym oraz błękitnym elementom wystroju wnętrza poczujesz się w strefie komfortu i wypoczynku.Pokój zawiera elegancką łazienkę z wanną zaopatrzoną w kosmetyki, ręczniki oraz suszarkę do włosów. Aneks kuchenny zapewnia wszystkie niezbędne rzeczy do codziennego funkcjonowania.Do czasu zakończenia remontu restauracji oferujemy gościom śniadania a'la carte w restauracji oddalonej o 40 metrów od Naszego hotelu. W ofercie za dodatkową opłatą posiadamy również łóżeczka turystyczne dla Naszych najmłodszych gości oraz wyrażamy zgodę na pobyt Waszego pupila zgodnie z regulaminem."
    },
    {
      type: "De Lux",
      roomNumbers: [44],
      mainDescription: {
        features: ["balkon z widokiem na jezioro", "salon z aneksem kuchennym"],
        bed: "sypialnia z łóżkiem małżeńskim",
        extraBed: "rozkładana kanapa",
        airConditioning: "indywidualnie sterowana",
        bathroom: "łazienka z wanną",
        towels: true,
        fridge: true,
        size: 43,
        maxGuests: 5,
        elevator: true,
      },
      icons: {
        "features": {
          "balcony": "balcony",
          "kitchen": "kitchen",
        },
        "bed": "bed",
        "extraBed": "weekend",
        "airConditioning": "air",
        "bathroom": "bathtub",
        "towels": "bath_towel",
        "fridge": "kitchen",
        "size": "straighten",
        "maxGuests": "people_alt"
      },
      detailedEquipment: [
        "salon z aneksem kuchennym (lodówka, płyta indukcyjna, piekarnik, zmywarka)",
        "rozkładana kanapa",
        "rozkładany fotel",
        "sypialnia z łóżkiem małżeńskim",
        "TV w salonie oraz sypialni",
        "internet",
        "toaletka z lustrem",
        "klimatyzacja indywidualnie sterowana",
        "zestaw kawa / herbata",
        "ręczniki",
        "kosmetyki",
        "łazienka z prysznicem",
        "suszarka do włosów",
        "sauna",
        "pralka",
        "żelazko oraz deska do prasowania"
      ],
      description: "Spędź wyjątkowy czas w pokoju typu De Lux z zapierającym dech w piesi widokiem na jezioro. Przestrzeń jest jasna i funkcjonalna, a dzięki białym oraz błękitnym elementom wystroju wnętrza poczujesz się w strefie komfortu i wypoczynku. Pokój zawiera elegancką łazienkę z prysznicem oraz sauną, zaopatrzoną w kosmetyki, ręczniki i suszarkę do włosów. Aneks kuchenny zapewnia wszystkie niezbędne rzeczy do codziennego funkcjonowania. Do czasu zakończenia remontu restauracji oferujemy gościom śniadania a'la carte w restauracji oddalonej o 40 metrów od Naszego hotelu. W ofercie za dodatkową opłatą posiadamy również łóżeczka turystyczne dla Naszych najmłodszych gości oraz wyrażamy zgodę na pobyt Waszego pupila zgodnie z regulaminem."
    },
    {
      "type": "Superior",
      "roomNumbers": [12, 14, 24, 25, 35, 46],
      "mainDescription": {
        "view": "jezioro",
        "bed": "łóżko małżeńskie z możliwością rozłączenia na dwa pojedyncze",
        "extraBed": "rozkładany fotel",
        "airConditioning": "indywidualnie sterowana",
        "bathroom": "łazienka z prysznicem",
        "towels": true,
        "fridge": true,
        "size": 23,
        "maxGuests": 3,
        elevator: true
      },
      "icons": {
        "roomType": "hotel",
        "view": "visibility",
        "bed": "king_bed",
        "extraBed": "weekend",
        "airConditioning": "ac_unit",
        "bathroom": "shower",
        "towels": "dry_cleaning",
        "fridge": "kitchen",
        "size": "square_foot",
        "maxGuests": "groups"
      },
      "detailedEquipment": [
        "łóżko małżeńskie z możliwością rozłączenia na dwa pojedyncze",
        "rozkładany fotel",
        "TV",
        "internet",
        "toaletka z lustrem",
        "lodówka",
        "klimatyzacja indywidualnie sterowana",
        "suszarka do włosów",
        "zestaw kawa / herbata",
        "ręczniki",
        "kosmetyki",
        "łazienka z prysznicem"
      ],
      "description": "Spędź wyjątkowy czas w pokoju typu Superior z zapierającym dech w piesi widokiem na jezioro. Przestrzeń jest jasna i funkcjonalna, a dzięki białym oraz błękitnym elementom wystroju wnętrza poczujesz się w strefie komfortu i wypoczynku.Pokój zawiera elegancką łazienkę z prysznicem zaopatrzoną w kosmetyki, ręczniki oraz suszarkę do włosów. Do czasu zakończenia remontu restauracji oferujemy gościom śniadania a'la carte w restauracji oddalonej o 40 metrów od Naszego hotelu. W ofercie za dodatkową opłatą posiadamy również łóżeczka turystyczne dla Naszych najmłodszych gości oraz wyrażamy zgodę na pobyt Waszego pupila zgodnie z regulaminem."
    },
    {
      "type": "Apartament",
      "roomNumbers": [31, 41],
      "mainDescription": {
        "bedrooms": 2,
        "beds": ["łóżko małżeńskie", "łóżko małżeńskie z możliwością rozłączenia na dwa pojedyncze"],
        "extraBed": "rozkładany fotel",
        "airConditioning": "indywidualnie sterowana",
        "bathroom": "łazienka z prysznicem",
        "towels": true,
        "fridge": true,
        "size": 27,
        "maxGuests": 5
      },
      "icons": {
        "roomType": "apartment",
        "bedrooms": "meeting_room",
        "bed": "king_bed",
        "extraBed": "weekend",
        "airConditioning": "ac_unit",
        "bathroom": "shower",
        "towels": "dry_cleaning",
        "fridge": "kitchen",
        "size": "square_foot",
        "maxGuests": "groups"
      },
      "detailedEquipment": [
        "TV",
        "toaletka z lustrem",
        "lodówka",
        "klimatyzacja indywidualnie sterowana",
        "suszarka do włosów"
      ],
      "description": "Spędź wyjątkowy czas w Apartamencie który zachwyca przytulną atmosferą oraz detalami, dzięki którym poczujecie się jak w domu. Przestrzeń jest jasna i funkcjonalna, a dzięki białym oraz błękitnym elementom wystroju wnętrza poczujesz się w strefie komfortu i wypoczynku.Pokój zawiera elegancką łazienkę z prysznicem zaopatrzoną w kosmetyki, ręczniki oraz suszarkę do włosów. Do czasu zakończenia remontu restauracji oferujemy gościom śniadania a'la carte w restauracji oddalonej o 40 metrów od Naszego hotelu. W ofercie za dodatkową opłatą posiadamy również łóżeczka turystyczne dla Naszych najmłodszych gości oraz wyrażamy zgodę na pobyt Waszego pupila zgodnie z regulaminem."
    }
  ],
  cookiesOptionActive: true,
  offersSettings: [{}],
  buttonColor: '#008781',
  showHome: true,
  showFilters: false,
  redirectToOtherHotel: {
    on: false,
    text: ""
  }
};